import {useParams} from "react-router";
import React, {useEffect} from "react";
import LateGroupForm from "../components/LateGroup/LateGroupForm";
import {useLoggedUser} from "../context/LoggedUserContext";

const LateGroup = () => {
    const {user, isLoading} = useLoggedUser();

    useEffect(() => {
        if (!isLoading && !user) {
            window.location.href = '/auth/steam';
        }

        console.log(isLoading, user);
    }, [isLoading, user]);

    return (
        <>
            {user &&
                <main className={`text-white`}>
                    <div className="container align-items-center justify-content-center mt-5">
                        <div className="row justify-content-center mt-5">
                            <div className="col-9">
                                <LateGroupForm/>
                            </div>
                        </div>
                    </div>
                </main>
            }
        </>
    )
}

export default LateGroup;
